import React from 'react'

import { Timeline as MuiTimeline } from '@mui/lab'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import Container from './styles'

function Timeline(props) {
  const { actualStep, steps } = props
  const stepArray = addKeyToObjectsArray(Object.keys(steps).map(field => { return { text: steps[field] } }))
  
  let dotChecked = typeof(actualStep) !== "string"
  let dashChecked = typeof(actualStep) !== "string"

  return (
    <Container>
      <div className='wrapper'>
        <div className='timeline-fixture' />
        <MuiTimeline position='left'>
          {stepArray.map((step, index) => {
            if (stepArray[index - 1]?.text === actualStep)
              dotChecked = true
            if (stepArray[index]?.text === actualStep)
              dashChecked = true
            return (
              <TimelineItem key={step.key}>
                <TimelineSeparator>
                  <TimelineDot style={{ backgroundColor: dotChecked ? '#E8E8E8' : '#34A853' }} />
                  {
                    (stepArray.length - 1) > index && 
                    <TimelineConnector style={{ backgroundColor: dashChecked ? '#E8E8E8' : '#34A853' }} />
                  }
                </TimelineSeparator>
                <TimelineContent className='timeline-text'>{step.text}</TimelineContent>
              </TimelineItem>
            )
          })}
        </MuiTimeline>
      </div>
    </Container>
  )
}

export default Timeline
